import { Row, Col, Container, Card, Button } from "react-bootstrap";
import Layout from "../../components/Layout";
import rectangle from '../../assets/images/rectangle.svg'
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Plans = () => {

    const navigate = useNavigate()


    const plans = [
        {
            id: 1,
            name: 'Classic Plan',
            amount: 'FREE',
            tenure: '30 Days - Trials',
            benefits: [
                {
                    id: 1,
                    status: 'active',
                    name: 'Free Business Bank Acc.',
                    terms: false,
                    paid:false,
                    sm: 'Moniepoint, GTBank, Wema,.'
                },
                {
                    id: 2,
                    status: 'active',
                    name: 'Remote Store Mgt.',
                    terms: false,
                    paid:false,
                },
                {
                    id: 3,
                    status: 'active',
                    name: 'Inventory Mgt.',
                    terms: false,
                    paid:false,
                    sm: 'Store management'
                },
                {
                    id: 4,
                    status: 'active',
                    name: 'Storefront',
                    terms: false,
                    paid:false,
                    sm: 'Sales Register'
                },
                {
                    id: 5,
                    status: 'active',
                    name: "Accept Int'L Payments",
                    terms: false,
                    paid:false,
                    sm: 'USD | GBP | CAD'
                },
                {
                    id: 6,
                    status: 'active',
                    name: 'CRM Tools',
                    terms: false,
                    paid:false,
                    sm: 'Marketing Tool, Customer Loyalty, Customer Rating'
                },
                {
                    id: 7,
                    status: 'active',
                    name: 'Supplier/Vendor Mgt.',
                    terms: false,
                    paid:false,
                },
                {
                    id: 8,
                    status: 'active',
                    name: 'Tax Calculator',
                    terms: true,
                    paid: false
                },
                {
                    id: 9,
                    status: 'active',
                    name: 'Business Performance Tool',
                    terms: false,
                    paid: false
                },
                {
                    id: 10,
                    status: 'active',
                    name: 'Digital Invoicing',
                    terms: false,
                    paid: false
                },
                {
                    id: 11,
                    status: 'active',
                    name: 'On-Click Business Incorp',
                    terms: false,
                    paid: true
                },
                {
                    id: 12,
                    status: 'active',
                    name: 'Sales Tracker Mgt.',
                    terms: false,
                    paid: false
                },
                {
                    id: 13,
                    status: 'active',
                    name: 'Email Support',
                    terms: false,
                    paid: false
                },
            ],
        },
        {
            id: 2,
            name: 'Essential Plan',
            amount: '₦12,300',
            tenure: 'Paid MONTHLY',
            benefits: [
                {
                    id: 1,
                    status: 'active',
                    name: 'Free Business Bank Acc.',
                    terms: false,
                    paid:false,
                    sm: 'Moniepoint, GTBank, Wema,.'
                },
                {
                    id: 2,
                    status: 'active',
                    name: 'Remote Store Mgt.',
                    terms: false,
                    paid:false,
                },
                {
                    id: 3,
                    status: 'active',
                    name: 'Inventory Mgt.',
                    terms: false,
                    paid:false,
                },
                {
                    id: 3.1,
                    status: 'active',
                    name: 'Business Disaster Insurance',
                    terms: false,
                    paid:false,
                    sm: '“Cover Upto N2.5M”'
                },
                {
                    id: 4,
                    status: 'active',
                    name: 'Storefront',
                    terms: false,
                    paid:false,
                    sm: 'Sales Register'
                },
                {
                    id: 5,
                    status: 'active',
                    name: "Accept Int'L Payments",
                    terms: false,
                    paid:false,
                    sm: 'USD | GBP | CAD'
                },
                {
                    id: 6,
                    status: 'active',
                    name: 'CRM Tools',
                    terms: false,
                    paid:false,
                    sm: 'Marketing Tool, Customer Loyalty, Customer Rating'
                },
                {
                    id: 7,
                    status: 'active',
                    name: 'Supplier/Vendor Mgt.',
                    terms: false,
                    paid:false,
                },
                {
                    id: 7.1,
                    status: 'active',
                    name: 'Business File Management',
                    terms: false,
                    paid:false,
                },
                {
                    id: 8,
                    status: 'active',
                    name: 'Tax Calculator',
                    terms: true,
                    paid: false
                },
                {
                    id: 9,
                    status: 'active',
                    name: 'Business Performance Tool',
                    terms: false,
                    paid: false
                },
                {
                    id: 10,
                    status: 'active',
                    name: 'Digital Invoicing',
                    terms: false,
                    paid: false
                },
                {
                    id: 11,
                    status: 'active',
                    name: 'On-Click Business Incorp',
                    terms: false,
                    paid: true
                },
                {
                    id: 12,
                    status: 'active',
                    name: 'Sales Tracker Mgt.',
                    terms: false,
                    paid: false
                },
                {
                    id: 13,
                    status: 'active',
                    name: '24 x 5 Support',
                    terms: false,
                    paid: false
                },
            ],
        },
        {
            id: 3,
            name: 'Essential Plan',
            amount: '₦27,999',
            tenure: 'Paid QUARTERLY',
            benefits: [
                {
                    id: 1,
                    status: 'active',
                    name: 'Free Business Bank Acc.',
                    terms: false,
                    paid:false,
                    sm: 'Moniepoint, GTBank, Wema,.'
                },
                {
                    id: 2,
                    status: 'active',
                    name: 'Remote Store Mgt.',
                    terms: false,
                    paid:false,
                },
                {
                    id: 3,
                    status: 'active',
                    name: 'Inventory Mgt.',
                    terms: false,
                    paid:false,
                    sm: 'Store Management'
                },
                {
                    id: 3.1,
                    status: 'active',
                    name: 'Business Disaster Insurance',
                    terms: false,
                    paid:false,
                    sm: '“Cover Up to N10M”'
                },
                {
                    id: 4,
                    status: 'active',
                    name: 'Storefront',
                    terms: false,
                    paid:false,
                    sm: 'Sales Register'
                },
                {
                    id: 5,
                    status: 'active',
                    name: "Accept Int'L Payments",
                    terms: false,
                    paid:false,
                    sm: 'USD | GBP | CAD'
                },
                {
                    id: 6,
                    status: 'active',
                    name: 'CRM Tools',
                    terms: false,
                    paid:false,
                    sm: 'Marketing Tool, Customer Loyalty, Customer Rating'
                },
                {
                    id: 7,
                    status: 'active',
                    name: 'Supplier/Vendor Mgt.',
                    terms: false,
                    paid:false,
                },
                {
                    id: 7.1,
                    status: 'active',
                    name: '1-Year Health Insurance',
                    terms: false,
                    paid:false,
                },
                {
                    id: 8,
                    status: 'active',
                    name: 'Tax Calculator',
                    terms: true,
                    paid: false
                },
                {
                    id: 9,
                    status: 'active',
                    name: 'Business Performance Tool',
                    terms: false,
                    paid: false
                },
                {
                    id: 10,
                    status: 'active',
                    name: 'Digital Invoicing',
                    terms: false,
                    paid: false
                },
                {
                    id: 11,
                    status: 'active',
                    name: 'On-Click Business Incorp',
                    terms: false,
                    paid: true
                },
                {
                    id: 12,
                    status: 'active',
                    name: 'Sales Tracker Mgt.',
                    terms: false,
                    paid: false
                },
                {
                    id: 13,
                    status: 'active',
                    name: '24 x 7 Support',
                    terms: false,
                    paid: false
                },
            ],
        },
    ];

    const subscribeNow = (plan) => {
        Swal.fire({
            title: `${plan.name} subscription`,
            text: `${plan.amount} will be charged from your main wallet. Do you wish to continue?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Proceed"
        })
        .then((result) => {
            if (result.isConfirmed) {
                // dispatch()
                Swal.fire({
                    icon: "success",
                    title: "Successfully Subscribed! This is test though",
                })
                .then(() => {
                    navigate('/subscriptions/plans')
                })
            }
        })
    }


    return (
        <Layout title="Subscription">
            <Container className="mt-3 px-4 mb-4">
                {
                    plans.length ? (
                        <Row>
                            {
                                plans.map((plan, index) => ( 
                                        <Col md={4} key={index}>
                                            <Card className="border-0 shadow-sm rounded-16">
                                                <Card.Body className="py-4 pe-3 ps-3 pricing">
                                                    <h4 className="text-secondary">{plan.name}</h4>
                                                    <div className="mb-3 mt-3">
                                                        <h1 className="text-bold font-bold">{plan.amount}</h1>
                                                    </div>
            
                                                    <div className="plan">
                                                        {/* <div className="pricing mb-3">
                                                            <p className="m-0">Other Prices:</p>
                                                            <div className="price-tags">
                                                                <h5>
                                                                    ₦40,000/<small>6months</small>, 
                                                                    ₦80,000/<small>12months</small> 
                                                                </h5>
                                                            </div>
                                                        </div> */}
                                                        <h6 className="mb-2">{plan.tenure}</h6>
                                                        {
                                                            plan.benefits.length ? (
                                                                <ul>
                                                                    {
                                                                        plan.benefits.map((plan, index) => (
                                                                            <li key={index}>
                                                                               <span className="me-2">
                                                                                    <img src={rectangle} alt="icon" />
                                                                                </span> 
                                                                                <p>
                                                                                    {plan.name} 
                                                                                    <small className="text-primary font-bold d-block">{plan.sm}</small>
                                                                                </p>
                                                                                    {/* { 
                                                                                        plan.terms ?  
                                                                                            <small className="text-danger d-block font-bold">(Please read T&C)</small> : 
                                                                                        plan.paid ?  
                                                                                            <small className="text-danger d-block font-bold">(Paid service)</small> : null
                                                                                    } */}
                                                                            </li>
                                                                        ))
                                                                    }
                                                                </ul>
                                                            ) : null
                                                        }
                                                        <Button 
                                                            type="button" 
                                                            variant="primary" 
                                                            // variant={plan.name === "Premium Plan" ? "primary" : "light"} 
                                                            disabled={plan.name === "Classic Plan"}
                                                            className={`form-control mt-5 `}
                                                            onClick={() => subscribeNow(plan)}
                                                        >
                                                            {/* className={`form-control mt-5 ${plan.name === 'Premium Plan' ? null : 'bg---primary'} `}> */}
                                                                Subscribe
                                                        </Button>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                ))
                            }
                        </Row>
                    ) : (
                        <div className="text-center col-md-12">
                            <p>No plans available</p>
                        </div>
                    )
                }
            </Container>
        </Layout>
    );
}

export default Plans;